export const getCountryFromBrowserLanguage = () => {
  /*
   * Getting the country from navigator.language is not reliable:
   * - the split character (-, _) is not wel defined, especially for older browsers
   * - some older browsers return the country in lowercase
   * We tried to solve for all edge cases here.
   */
  const { language: locale } = navigator
  const [, country] = locale.split(/[_-]{1}/)
  return country?.toUpperCase()
}
